import { render, staticRenderFns } from "./HistoricalPlansTabs.vue?vue&type=template&id=6815a3e9&"
import script from "./HistoricalPlansTabs.vue?vue&type=script&lang=js&"
export * from "./HistoricalPlansTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports